<template>
  <div v-if="$route.name !='scorecard' && $route.name !='summary' && $route.name != 'display' && $route.name != 'lanes'">
  <nav class="navbar" role="navigation" aria-label="main navigation">
    <div class="container">
      <div class="navbar-brand">
        <a class="navbar-item" href="/">
          <span class="axes2-title">
            <img class="axes2-title-logo" :src="`${publicPath}img/Axes2-text-logo-sm.png`"/>
          </span>
        </a>
        <a role="button" id="burger-button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbar">
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>
      <div id="navbar" class="navbar-menu">
        <div class="navbar-start">
          <router-link v-if="$auth.isAuthenticated" to="/throw" class="navbar-item throw-link">Throw</router-link>
          <a href="/display" target="_blank" class="navbar-item display-link">Live</a>
          <router-link to="/ranking2" class="navbar-item rankings-link">Rankings</router-link>
          <router-link to="/best" class="navbar-item best-link">Top Scores</router-link>
          <router-link v-if="$auth.isAuthenticated" to="/profile" class="navbar-item profile-link">Profile</router-link>
          <a href="/shop" target="_blank" class="navbar-item shop-link">Shop</a>
          <router-link v-if="$auth.isAuthenticated" to="/members" class="navbar-item members-link">Members</router-link>
          <router-link v-if="$auth.isAuthenticated && this.isAdmin()" to="/messages" class="navbar-item admin-link">Messages</router-link>
          <router-link v-if="$auth.isAuthenticated && this.isAdmin()" to="/activity" class="navbar-item activity-link">Activity</router-link>
        </div>
        <div class="navbar-end">
            <div class="navbar-item">
              <div class="buttons">
                <!-- Check that the SDK client is not currently loading before accessing is methods -->
                <div v-if="!$auth.loading">
                    <!-- show login when not authenticated -->
                    <a v-if="!$auth.isAuthenticated" @click="login" class="button"><strong>Login</strong></a>
                    <!-- show logout when authenticated -->
                    <a v-if="$auth.isAuthenticated" @click="logout" class="button"><strong>Logout</strong></a>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
  </nav>
  <div v-if="isOffline" class="online-status">
    <p>It looks like you're offline?</p>
  </div>
</div>
</template>

<script>
    export default {
    name: 'Nav',
    data () {
      return {
          publicPath: process.env.BASE_URL
      }
    },
    computed: {
    },
    methods: {
        isAdmin() {
          return this.$parent.isAdmin();
        },
        login() {
            this.$auth.loginWithRedirect();
        },
        // Log the user out
        logout() {
            this.$auth.logout({
            returnTo: window.location.origin
            });
        },
        mountBurger() {
          //https://bulma.io/documentation/components/navbar/
          // Get all "navbar-burger" elements
          const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

          // Check if there are any navbar burgers
          if ($navbarBurgers.length > 0) {

            // Add a click event on each of them
            $navbarBurgers.forEach( el => {
              el.addEventListener('click', () => {

                // Get the target from the "data-target" attribute
                const target = el.dataset.target;
                const $target = document.getElementById(target);

                // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
                el.classList.toggle('is-active');
                $target.classList.toggle('is-active');

              });
            });
          }
        }
      },
      computed: {
        networkStatus () {
          return this.isOnline ? 'ONLINE' : 'OFFLINE'
        }
      },
      mounted(){
        this.mountBurger();
      }
    }
</script>

<style lang="scss" scoped>
  .online-status {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
    font-size: 1.1em;
    width: 100%;
    text-align: center;
    padding: 8px;
    background-color: #d88d00;
    color: white;
    font-weight: bold;
  }
  nav {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
    font-size: 1.1em;
    background-color: #1a1a1a;
    border-bottom: 1px solid #333;
    padding: 10px 0;
    
    a {
      font-weight: 500;
      color: #b5b5b5;
      transition: color 0.2s;
      
      &.router-link-exact-active {
        color: #ffdd57; /* Axe yellow */
        background-color: transparent !important;
      }
    }
    a:hover {
      color: white;
    }
  }

  .burger {
    color: #b5b5b5;
  }
  .burger:hover {
    background-color: rgba(255,255,255,0.05);
  }

  .axes2-title {
      width: 200px;
  }
  .axes2-title-logo {
    max-height: 50px !important;
    padding-right: 20px;
    height: auto;
  }
  
  .navbar-item {
    background-color: transparent !important;
    font-size: 0.95em;
    padding: 0.5rem 0.5rem; /* Tighter padding */
  }
  
  .navbar-item:hover, .navbar-item:active, .router-link-exact-active {
    background-color: transparent !important;
    color: #ffdd57 !important;
  }

  .navbar-brand, .navbar-menu {
    background-color: #1a1a1a;
  }
  
  /* Allow wrapping if needed */
  .navbar-menu {
      flex-wrap: wrap;
  }

  /* Login/Logout Buttons */
  .button {
    background-color: transparent;
    border: 1px solid #48c774;
    color: #48c774;
    transition: all 0.2s;
    font-size: 0.9em;
  }
  .button:hover {
    background-color: #48c774;
    color: white;
    border-color: #48c774;
  }
</style>